import styled from 'styled-components'

export const RecentlyUsedContainer = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 32px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`

export const RecentlyUsedItemsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 8px;
  margin-top: 12px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`
